import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";
import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import logo from "@/assets/ace-anchor-logo.png";
const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogoClick = (e: React.MouseEvent) => {
    e.preventDefault();
    navigate('/');
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  };

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, hash: string) => {
    e.preventDefault();
    setMobileMenuOpen(false);
    
    if (location.pathname !== '/') {
      navigate('/' + hash);
    } else {
      const element = document.querySelector(hash);
      element?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return <header className="fixed top-0 left-0 right-0 z-50 bg-background/80 backdrop-blur-lg border-b border-border">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a href="/" onClick={handleLogoClick} className="flex items-center gap-1 cursor-pointer hover:opacity-80 transition-opacity">
            
            <div className="text-2xl font-bold text-primary">
              Ace Anchor
            </div>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <a href="#hero" onClick={(e) => handleNavClick(e, '#hero')} className="text-foreground hover:text-primary transition-colors font-medium">
              Home
            </a>
            <a href="#about" onClick={(e) => handleNavClick(e, '#about')} className="text-foreground hover:text-primary transition-colors font-medium">
              About
            </a>
            <a href="#services" onClick={(e) => handleNavClick(e, '#services')} className="text-foreground hover:text-primary transition-colors font-medium">
              Services
            </a>
            <a href="#faq" onClick={(e) => handleNavClick(e, '#faq')} className="text-foreground hover:text-primary transition-colors font-medium">
              FAQ
            </a>
            <a href="#contact" onClick={(e) => handleNavClick(e, '#contact')} className="text-foreground hover:text-primary transition-colors font-medium">
              Contact
            </a>
            <a href="/login" className="text-foreground hover:text-primary transition-colors font-medium">
              Login
            </a>
          </nav>

          {/* CTA Buttons */}
          <div className="hidden md:flex items-center gap-4">
            <Button variant="outline" asChild>
              <a href="https://wa.me/61400000000" target="_blank" rel="noopener noreferrer">
                Chat with Us
              </a>
            </Button>
            <Button variant="accent" asChild>
              <a href="#contact" onClick={(e) => handleNavClick(e, '#contact')}>
                Book Now
              </a>
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button className="md:hidden p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu">
            {mobileMenuOpen ? <X className="w-6 h-6 text-foreground" /> : <Menu className="w-6 h-6 text-foreground" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && <div className="md:hidden py-6 border-t border-border">
            <nav className="flex flex-col gap-4">
              <a href="#hero" className="text-foreground hover:text-primary transition-colors font-medium px-4 py-2" onClick={(e) => handleNavClick(e, '#hero')}>
                Home
              </a>
              <a href="#about" className="text-foreground hover:text-primary transition-colors font-medium px-4 py-2" onClick={(e) => handleNavClick(e, '#about')}>
                About
              </a>
              <a href="#services" className="text-foreground hover:text-primary transition-colors font-medium px-4 py-2" onClick={(e) => handleNavClick(e, '#services')}>
                Services
              </a>
              <a href="#faq" className="text-foreground hover:text-primary transition-colors font-medium px-4 py-2" onClick={(e) => handleNavClick(e, '#faq')}>
                FAQ
              </a>
              <a href="#contact" className="text-foreground hover:text-primary transition-colors font-medium px-4 py-2" onClick={(e) => handleNavClick(e, '#contact')}>
                Contact
              </a>
              <a href="/login" className="text-foreground hover:text-primary transition-colors font-medium px-4 py-2" onClick={() => setMobileMenuOpen(false)}>
                Login
              </a>
              <div className="px-4 pt-4 flex flex-col gap-3">
                <Button variant="outline" className="w-full" asChild>
                  <a href="https://wa.me/61400000000" target="_blank" rel="noopener noreferrer" onClick={() => setMobileMenuOpen(false)}>
                    Chat with Us
                  </a>
                </Button>
                <Button variant="accent" className="w-full" asChild>
                  <a href="#contact" onClick={(e) => handleNavClick(e, '#contact')}>
                    Book Now
                  </a>
                </Button>
              </div>
            </nav>
          </div>}
      </div>
    </header>;
};
export default Header;